<template>
	<div class="user-manager">
		Database creator
	</div>
</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import Login from '@/components/Login.vue'

export default
{
	name: 'DatabaseCreator',

	components:
	{
		
	}
}

</script>